export const routes = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/sign-up",
  FORGET: "/forget-password",
  OTP_VERIFICATION: "/otp-verification",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_WITH_TOKEN: "/reset-password/:userId/:token",
  EMAIL_VERIFICATION: "/email-verification",
  EMAIL_VERIFICATION_OTP: "/email-verification-otp",
  SELLER_REGISTRATION: "/seller-registration",
  REGISTRATION_COMPLETE: "/registration-complete",
  DASHBOARD: "/dashboard",
  SELLER_DASHBOARD: "/seller-dashboard",
  MARKETPLACE_DASHBOARD: "/market-dashboard",
  MARKETPLACE: "/marketplace",
  SEARCH: "/search",
  SELLER_STORE: "/seller/:sellerId",
  CARD_DETAIL: "/marketplace/card/:cardId",
  CREATE_LISTING: "/create-listing",
  LISTING_DETAILS: "/marketplace/card/:cardId/:listId",
  /* The buyer's saved cards, as a page of their own. It is reached from the
     header heart and from the account menu, and it is NOT the dashboard's
     collection tab: same rows, but that one is a management table inside the
     console and this is a buying surface you land on mid-browse. */
  COLLECTION: "/collection",
  /* ADMIN ONLY, despite the bare path. `/order-tracking` is a track-by-
     reference LOOKUP — you land on an empty field asking for a tracking ID —
     and no buyer or seller surface offers it any more. The route survives
     because `SellerDashboard/OrderTable/OrderDetailsDrawer` still navigates
     here for a non-admin, and admin's own console renders the same view at
     `/admin-order-tracking`. */
  ORDER_TRACKING: "/order-tracking",
  /* The cart review step. This — NOT `/checkout` — is where anything that
     means "take me to my cart" belongs: the cart page is the only thing that
     writes the `orderItems_*` handoff `/checkout` reads, so linking straight
     to checkout lands the buyer on an empty order. */
  CART: "/cart",
  CHECKOUT: "/checkout",
  CREATE_LABEL: "/create-label",
  ADMIN: "/admin",
  PAYMENTSUCCESS: "/payment-successfull",

  PAYMENTFAILED: "/payment-failed",
  PROFILE: "/profile",
  SETS: "/sets",
  SETS_CATEGORY: "/sets/category/:tcgId",
  SETS_CATEGORY_SET: "/sets/category/:tcgId/:setSlug",
  ADMIN_SYSTEM_SETTINGS: "/admin-system-settings",
};
